import { render, staticRenderFns } from "./registerEntry_tl4.vue?vue&type=template&id=59cfcc3a&scoped=true"
import script from "./registerEntry_tl4.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl4.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl4.scss?vue&type=style&index=0&id=59cfcc3a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfcc3a",
  null
  
)

export default component.exports